import axios, { AxiosResponse } from 'axios';

let logoutFunction = null; // Variable to store the logout function

// Create an axios instance
const jwtAxios = axios.create({
  baseURL: 'https://api.trigon-acesoft.ca/', // Replace with your API base URL
  // baseURL:'http://localhost:5000/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include the Authorization token
jwtAxios.interceptors.request.use(
  (config) => {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Add response interceptor to handle specific errors
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.msg === 'Token is not valid') {
      console.log('Need to logout user');
      if (logoutFunction) {
        logoutFunction(); // Call the logout function
      }
    }
    return Promise.reject(err);
  }
);

// Utility function to set the logout function
export const setLogoutFunction = (logoutFn) => {
  logoutFunction = logoutFn;
};

export default jwtAxios;
